import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { TogglePanelCallback } from 'angular/custom/components/toggle-panel.component';

class ContractingServiceComponentCtrl implements ng.IController {
    private contractingService: any;
    private originalContractingService: ContractingServiceDto;

    public tsoRefId: number;
    public isNewContractingService: boolean = false;
    public contractingServicePanelExpanded: boolean = false;
    public onDelete: Function;
    public onCreateSuccess: Function;
    public index: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.isNewContractingService = this.contractingService.id == null;
        this.contractingServicePanelExpanded = this.isNewContractingService;

        if (!this.isNewContractingService) {
            this.originalContractingService = angular.copy(
                this.contractingService
            );
        } else {
            this.contractingService = {
                serviceLabel: null,
                serviceEmail: null,
                fieldLabels: [''],
                enabled: true
            };
        }
    }

    public createContractingService() {
        this.cleanUpFiledLabels();
        this.TransmissionSystemOperator.createContractingService(
            { id: this.tsoRefId },
            this.contractingService,
            (response: ContractingServiceDto) => {
                this.growl.show('Successfully created.', 'success', {
                    delay: 2000
                });
                this.contractingService = response;
                this.originalContractingService = angular.copy(
                    this.contractingService
                );
                this.isNewContractingService = false;
                this.contractingServicePanelExpanded = false;
                this.onCreateSuccess();
            },
            this.errorHandler
        );
    }

    public updateContractingService() {
        this.cleanUpFiledLabels();
        return this.TransmissionSystemOperator.updateContractingService(
            {
                id: this.tsoRefId,
                contractingServiceId: this.contractingService.id
            },
            this.contractingService,
            (response: ContractingServiceDto) => {
                this.growl.show('Successfully changed.', 'success', {
                    delay: 2000
                });
                this.contractingService = response;
                this.originalContractingService = angular.copy(
                    this.contractingService
                );
                this.contractingServicePanelExpanded = false;
            },
            (err: any) => {
                this.errorHandler(err);
                this.contractingService = angular.copy(
                    this.originalContractingService
                );
            }
        ).$promise;
    }

    private cleanUpFiledLabels() {
        this.contractingService.fieldLabels =
            this.contractingService.fieldLabels.filter(
                (x) => x !== null && x != ''
            );
    }

    public deleteContractingService() {
        this.TransmissionSystemOperator.deleteContractingService(
            {
                id: this.tsoRefId,
                contractingServiceId: this.contractingService.id
            },
            null,
            (response: any) => {
                this.growl.show('Successfully deleted.', 'success', {
                    delay: 2000
                });
                console.log('id in child: ' + this.contractingService.id);
                this.onDelete({ index: this.index });
            },
            this.errorHandler
        );
    }

    public equalsOriginal() {
        return angular.equals(
            this.originalContractingService,
            this.contractingService
        );
    }

    public discardChanges() {
        this.contractingService = angular.copy(this.originalContractingService);
    }

    public addEntryField() {
        this.contractingService.fieldLabels.push('');
    }

    public deleteEntryField(index: number) {
        this.contractingService.fieldLabels.splice(index, 1);
    }

    public toggleEnabled(cb: TogglePanelCallback) {
        try {
            this.updateContractingService()
                .then(() => cb(true))
                .catch(() => cb(false));
        } catch (e) {
            cb(false);
            throw e;
        }
    }
}

angular.module('app').component('pkpContractingService', {
    controller: ContractingServiceComponentCtrl,
    template:
        require('app/operator-settings-general/contracting-service.component.html'),
    bindings: {
        index: '<',
        tsoRefId: '<',
        contractingService: '<',
        onCreateCancel: '&',
        onCreateSuccess: '&',
        onDelete: '&'
    }
});
